import { EnumPerfilUsuario } from "../enums/EnumPerfilUsuario";
import { OpcaoModoUso } from "./OpcaoModoUso";

export const ListaOpcoesModoUso: OpcaoModoUso[] = [
  { descricao: "Estudante", tipo: EnumPerfilUsuario.Estudante, dica: "" },
  { descricao: "Concurseiro", tipo: EnumPerfilUsuario.Concurseiro, dica: "" },
  { descricao: "Advogado", tipo: EnumPerfilUsuario.Advogado, dica: "" },
];
